<template>
  <VMenu
    :open-on-click="$vuetify.breakpoint.xs"
    :open-on-hover="!$vuetify.breakpoint.xs"
    transition="slide-y-transition"
    rounded="4"
    attach
    close-delay="750"
    nudge-bottom="18"
    :nudge-left="$vuetify.breakpoint.xs ? '236' : '300'"
    :nudge-width="$vuetify.breakpoint.xs ? '231' : '295'"
    offset-y
  >
    <template #activator="{ on, attrs }">
      <VAvatar
        class="mr-2"
        color="brandingPrimary"
        data-test="cabinetMenuAvatar"
        size="36"
        v-bind="attrs"
        v-on="on"
      >
        <span class="white--text text-h5 text-uppercase body-1">{{ firstLetters }}</span>
      </VAvatar>
    </template>
    <VList
      class="py-0"
      dense
    >
      <VListItem>
        <VListItemContent>
          <VListItemTitle class="body-1 py-1">
            <span v-html="$t('cabinet.title', { fullName: fullName })" />
          </VListItemTitle>
        </VListItemContent>
      </VListItem>
      <VDivider class="ma-0" />
      <VListItem
        v-for="(item, index) in getLinks"
        :key="index"
        :to="{ name: item.value }"
        :data-test="`menuItem${item.value}`"
        class="header__link body-1 focus"
        exact
        exactActiveClass="header__active-link"
      >
        <slot name="customCabinetOption">
          <VListItemTitle class="body-1 d-flex py-2">
            <VListItemIcon class="mr-6">
              <VIcon>{{ item.icon }}</VIcon>
            </VListItemIcon>
            <VListItemContent>
              {{ $t(item.text) }}
            </VListItemContent>
          </VListItemTitle>
        </slot>
      </VListItem>
      <VListItem
        :key="`${getLogOutItem.value}`"
        class="header__link body-1 focus"
        data-test="menuItemLogOut"
        exact
        exactActiveClass="header__active-link"
        @click="$emit('openLogOutDialog')"
      >
        <VListItemTitle class="body-1 d-flex py-2">
          <VListItemIcon class="mr-6">
            <VIcon>{{ getLogOutItem.icon }}</VIcon>
          </VListItemIcon>
          <VListItemContent>
            {{ $t(getLogOutItem.text) }}
          </VListItemContent>
        </VListItemTitle>
      </VListItem>
    </VList>
  </VMenu>
</template>
<script lang="ts">
export default {
  name: 'TheCabinetMenu',
};
</script>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  firstLetters: {
    type: String,
    default: null,
  },
  fullName: {
    type: String,
    default: null,
  },
  cabinetToolbarItems: {
    type: Array,
    default: () => [],
  },
});

const getLogOutItem = computed(() => (props.cabinetToolbarItems as any[]).find(({ value }) => value === 'LogOut'));
const getLinks = computed(() => (props.cabinetToolbarItems as any[]).filter(({ value }) => value !== 'LogOut'));
</script>
<style scoped lang="scss">
@import "@slg/web-customer-shared/src/style/headerLinks.scss";
.v-icon {
  color: rgba(0,0,0,.54) !important;
}

.focus {
  &:hover {
    .v-icon::before {
      color: var(--v-brandingPrimary-base) !important;
    }
  }
}
</style>
